import { merge } from 'ramda';
import '../constants/AppConstants';
import * as types from '../constants/ActionTypes';

const auth = (state = {}, action) => {
  switch (action.type) {
    case types.SET_AUTH:
      return merge(state, { auth: action.payload });
    case types.REMOVE_AUTH:
      return merge(state, { auth: undefined });
    default:
      return state;
  }
};

export default auth;
